import { render, staticRenderFns } from "./OptionSwitch.vue?vue&type=template&id=b9e48736&scoped=true&"
import script from "./OptionSwitch.vue?vue&type=script&lang=js&"
export * from "./OptionSwitch.vue?vue&type=script&lang=js&"
import style0 from "./OptionSwitch.vue?vue&type=style&index=0&id=b9e48736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e48736",
  null
  
)

export default component.exports